<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
  border: 0 none;
}
input{ outline:none;}
li{ list-style:none;}
img{ border:0 none; vertical-align:top;}
em,i,b{ font-style:normal;}
a{ text-decoration:none; cursor: pointer; color: #000;}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  color: #2c3e50;
	min-width: 1200px;
}
.clearFix{ width:1200px; height:auto; margin:0px auto; *zoom:1; }
.clearFix:after{ content:""; clear:both; display:table; height:0; visibility:hidden;}
a{
  text-decoration: none;
}
.flex {display: -webkit-box;display: -webkit-flex;display: -ms-flexbox;display: flex;}
.flex-align-center {-webkit-box-align: center;-webkit-align-items: center;-ms-flex-align: center;align-items: center;}
.flex-pack-center {-webkit-box-pack: center;-webkit-justify-content: center;-ms-flex-pack: center;justify-content: center;}
.flex-pack-justify {-webkit-box-pack: justify;-webkit-justify-content: space-between;-ms-flex-pack: justify;justify-content: space-between;}
.flex-justify-space-around {-webkit-justify-content:space-around;justify-content: space-around;-moz-box-pack:space-around;-webkit--moz-box-pack:space-around;box-pack:space-around;}
.flex-pack-end {-webkit-box-pack: end;-webkit-justify-content: flex-end;-ms-flex-pack: end;justify-content: flex-end;}

.moduleBox{
			width: 1200px;
			margin: 0 auto;
			overflow: hidden;
		}
</style>



// WEBPACK FOOTER //
// src/App.vue